import TabsContainer from "../../components/uiKits/tabs";

const Tabs = () => {
  return <TabsContainer />;
};

export default Tabs;
